<rb-full-header [sticky]="true">
    <nav *rbMainNavItems aria-label="Navigation">
        <ng-container *ngIf="showHeaderMenu">
            <a [class.active] = "isActive('fleet')" (click)="goTo('fleet')" rbLoadingLink>Fleet</a>
            <a [class.active] = "isActive('vehicles')" (click)="goTo('vehicles')" rrbLoadingLink>Vehicles</a>
            <a [class.active] = "isActive('insights')" (click)="goTo('insights')" rbLoadingLink>Insights</a>
        </ng-container>
    </nav>
    <nav *rbMetaNavItems aria-label="Sub-Navigation">
        <ng-container *ngIf="showHeaderMenu">
            <a *ngIf="canAccessSettings" [class.active] = "isActive('settings')" (click)="goTo('settings')">Settings</a>
            <a [class.active] = "isActive('supported-vehicles')" (click)="goTo('supported-vehicles')">Supported Vehicles</a>
            <a (click)="openDialog(demoDialog)">Contact</a>
        </ng-container>
    </nav>
    <ng-template #demoDialog>
        <rb-dialog
            dialogTitle="Need Help?">
            <p>We're here to assist you! If you have any questions or need support, please don't hesitate to reach out.</p>
            <p><strong>Contact Us:</strong></p>
            <p>📧 Email: <a href="mailto:bitcgeotab.support@bosch-mcs.atlassian.net">bitcgeotab.support&#64;bosch-mcs.atlassian.net</a></p>
            <p>Our support team is available to help you with any issues or inquiries you may have. We aim to respond as quickly as possible to ensure you have a smooth experience.</p>
            <p>Thank you for choosing our service!</p>
        </rb-dialog>
    </ng-template>
    <ng-template #configChoiceDialog>
        <!-- Buttons are bound directly to handlers (optionalButtonAction / confirmationButtonAction). -->
        <rb-dialog
            dialogTitle="Battery in the Cloud Configuration"
            [optionalButtonLabel]="configChoiceButtonLabels.manualLabel"
            [optionalButtonAction]="manualChoiceAction"
            [confirmationButtonLabel]="configChoiceButtonLabels.automaticLabel"
            [confirmationButtonAction]="automaticChoiceAction">
            <p>Please choose how the Battery in the Cloud service should be configured for your fleet.</p>
            <p><strong>Automatic</strong>: the service will create a technical user <code>bitcgeotab.support@bosch.com</code> with the <code>GroupUserSecurityId</code> role, create the <code>bitc</code> security group, and assign the technical user to the <code>bitc</code> group.</p>
            <p><strong>Manual</strong>: you will create the technical user <code>bitcgeotab.support@bosch.com</code> (with the base role of your choice) and the <code>bitc</code> security group yourself, and assign the technical user to the group.</p>
            <p>In both cases, to onboard vehicles to Battery in the Cloud, assign the <code>bitc</code> group to the desired vehicles, either in the Assets page of MyGeotab or in the Settings page of this add-in.</p>
        </rb-dialog>
    </ng-template>
    <div *rbSubBrandHeader>{{title}}</div>
    <div *rbLogoHeader>
        <img [src]="logoUrl" alt="Bosch - Invented for life">
    </div>
</rb-full-header>
<ng-container *ngIf="currentPage === 'fleet' && fleetId.length > 0">
    <app-fleet-mgmt [fleetId]="fleetId"></app-fleet-mgmt>
</ng-container>
<ng-container *ngIf="currentPage === 'vehicles' && fleetId.length > 0">
    <app-vehicles-mgmt [fleetId]="fleetId" [fleetName]="fleetName"></app-vehicles-mgmt>
</ng-container>
<ng-container *ngIf="currentPage === 'insights' && fleetId.length > 0">
    <app-insights-mgmt [fleetId]="fleetId"></app-insights-mgmt>
</ng-container>
<ng-container *ngIf="currentPage === 'access-denied'">
    <app-home-page></app-home-page>
</ng-container>
<ng-container *ngIf="currentPage === 'configuration-pending'">
    <div class="row ms-0 me-0 mt-3">
        <rb-callout type="warning">
            <p>We're sorry, but this database is not configured yet and you are not authorized to configure it.
            Please contact your system administrator to complete the Battery in the Cloud configuration. Once it is done, reload this add-in.</p>
        </rb-callout>
    </div>
</ng-container>
<ng-container *ngIf="currentPage === 'manual-configuration'">
    <div class="row ms-1 me-1 mt-3">
            <p>You chose the <strong>manual</strong> configuration. Battery in the Cloud is not configured for this database yet, so the add-in content is not available until you complete the following steps in MyGeotab:</p>
            <ol class="ms-2">
                <li>Create the <code>bitc</code> security group.</li>
                <li>Create a technical user with username <code>bitcgeotab.support@bosch.com</code> and assign it to the <code>bitc</code> group.</li>
                <li>Assign the <code>bitc</code> group to the vehicles you want to onboard to the service, either in the Assets page of MyGeotab or in the Settings page of this add-in.</li>
                <!-- <li>Wait for the Battery in the Cloud support team to complete the technical account configuration.</li> -->
            </ol>
            <p>Once the configuration is completed, reload this add-in. It will then connect to your fleet.</p>
    </div>
</ng-container>
<ng-container *ngIf="currentPage === 'settings' && canAccessSettings">
    <app-settings [fleetId]="fleetId"></app-settings>
</ng-container>
<ng-container *ngIf="currentPage === 'supported-vehicles'">
    <app-supported-vehicles></app-supported-vehicles>
</ng-container>
<ng-container *ngIf="currentPage === 'legal-notice'">
    <app-legal-notice></app-legal-notice>
</ng-container>
<ng-container *ngIf="currentPage === 'corporate-information'">
    <app-corporate-information></app-corporate-information>
</ng-container>
<ng-container *ngIf="currentPage === 'open-source'">
    <app-open-source></app-open-source>
</ng-container>
<ng-container *ngIf="currentPage === 'customer-data'">
    <app-customer-data [companyData]="companyData" (companyDataSaved)="onCompanyDataSaved()"></app-customer-data>
</ng-container>
<ng-container *ngIf="currentPage === 'onboarding' && fleetId.length > 0">
    <app-vehicle-onboarding [fleetId]="fleetId"></app-vehicle-onboarding>
</ng-container>
<rb-footer-nav>
    <span class=" copyright">&copy; 2026 Robert Bosch GmbH</span>
    <nav aria-label="Footer Navigation">
        <a (click)="goTo('corporate-information')">Corporate information</a>
        <a (click)="goTo('legal-notice')">Legal notice</a>
        <a (click)="goTo('open-source')">Open source notice</a>
    </nav>
</rb-footer-nav>